import { setCookie } from 'lib/web/cookieUtils'

export const LEFT_PANE_WIDTH_COOKIE = 'tripPlannerLeftPaneWidth'
export const LEFT_PANE_WIDTH_DEFAULT = 55 // percent
const ONE_YEAR = 60 * 60 * 24 * 365

export function setLeftPaneWidthCookie(width: number) {
  setCookie(LEFT_PANE_WIDTH_COOKIE, `${width}`, ONE_YEAR, '/', 'Lax')
}
